export type EstateSummaryJSON = {
  estate_id?: number;
  advisor_group_id?: number;
  advisor_group_name?: string;
  tasks_assigned?: number;
  tasks_completed?: number;
  assets_inventoried?: AssetsMap;
  assets_value?: AssetsMap;
  TotalAssets?: string;
  percentage?: number;
  task_completed?: number;
};

export type AssetsMap = {
  total?: number | null;
  household?: number | null;
  financial?: number | null;
  realEstate?: number | null;
  vehicle?: number | null;
  digital?: number | null;
  other?: number | null;
  other2?: number | null;
};

export class EstateSummary {
  constructor(
    public estateId?: number,
    public group?: string,
    public tasksAssigned?: number | null,
    public tasksCompleted?: number | null,
    public percentageComplete?: number,
    public assetsInventoried?: AssetsMap | null,
    public assetsValue?: AssetsMap | null,
    public totalAssetValue?: string | null,
    public updatedAt?: string | null
  ) {}

  static fromJSON(estateSummary: EstateSummaryJSON): EstateSummary {
    if (estateSummary) {
      return new EstateSummary(
        undefined,
        undefined,
        estateSummary.tasks_assigned,
        estateSummary.tasks_completed,
        estateSummary.percentage,
        undefined,
        undefined,
        estateSummary.TotalAssets,
        undefined
      );
    } else {
      return new EstateSummary();
    }
  }
}
